import { render } from "./UserProfilePage.vue?vue&type=template&id=83ecb67e&scoped=true&ts=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts"

import "./UserProfilePage.vue?vue&type=style&index=0&id=83ecb67e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ecb67e"]])

export default __exports__